export abstract class BaseModel {
    ID: number;
    CreatedUtcDate: Date;
    CreatedBy: string;
    UpdatedUtcDate?: Date;
    UpdatedBy: string;
    Deleted: boolean;
}
